// extracted by mini-css-extract-plugin
export default {"interests__title":"interests-content_interests__title__2aerL","interests":"interests-content_interests__4vuz4","interests__item":"interests-content_interests__item__TMTxq"};